import { useStore } from "~/store";
import { useSchemaOrg } from "./useSchemaOrg";

export function useMetaTags(notaria:any, PageName:string, SubPage?:string) {
  const store = useStore()
  
  const PageNames: any = {
    Equipo: { propertyName: "Team", displayName: "Equipo" },
    index: { propertyName: "Home", displayName: "Inicio" },
    Home: { propertyName: "Home", displayName: "Inicio" },
    Servicios: { propertyName: "Servicios", displayName: "Servicios" },
    Blog: { propertyName: "Blog", displayName: "Blog" },
    Contacto: { propertyName: "Contacto", displayName: "Contacto" },
    Notarios: { propertyName: "Notarios", displayName: "Notarios" },
    Testimonios: { propertyName: "Testimonios", displayName: "Testimonios" }
  }

  let ThemePropertyName: string = PageNames[PageName] ? PageNames[PageName].propertyName : PageName
  let DisplayPageName: string = PageNames[PageName] ? PageNames[PageName].displayName : PageName
  const pageTheme = notaria.Theme[ThemePropertyName]

  const title = pageTheme?.Titulo?.Texto || DisplayPageName
  const description = pageTheme?.Description || ""
  const keywords = pageTheme?.Keywords || ""

  // Imagen para redes sociales (Prioridad: Banner > Logo > Default)
  const shareImageId = notaria.Theme?.Home?.Banner?.Imagen || notaria.Theme?.Home?.Banner?.ImagenLogo || ""
  const shareImage = shareImageId ? `https://${store.host}/appdata/static/${shareImageId}` : `https://${store.host}/favicon.ico`
  const shareUrl = `https://${store.host}${PageName === 'index' ? '' : '/' + PageName.toLowerCase()}`

  // 1. Prioridad: Etiquetas para SEO en Servidor (Lo que ve Google y Redes Sociales)
  useServerSeoMeta({
    title: title,
    description: description,
    keywords: keywords,
    // Open Graph
    ogTitle: `${title} | ${notaria.Nombre}`,
    ogDescription: description,
    ogImage: shareImage,
    ogUrl: shareUrl,
    ogType: 'website',
    ogLocale: notaria.Languaje === 'es' ? 'es_ES' : 'en_US',
    // Twitter
    twitterCard: 'summary_large_image',
    twitterTitle: `${title} | ${notaria.Nombre}`,
    twitterDescription: description,
    twitterImage: shareImage,
    // Otros
    robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    googleSiteVerification: notaria.Personalizar?.GoogleSiteVerification || undefined
  })

  // 2. Etiquetas de cabecera adicionales (Atributos HTML, Canonical, etc.)
  useHead({
    title: title,
    htmlAttrs: {
      lang: notaria.Languaje || 'es'
    },
    link: [
      { 
        rel: 'canonical', 
        href: `https://${store.host}/${PageName.toLowerCase()}/${SubPage ? SubPage.toLowerCase() : ''}`.replace(/\/$/, "") 
      }
    ]
  })

  // 3. Datos Estructurados (Schema.org)
  useSchemaOrg(notaria)
}